var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuySell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.024,
    height: 64,
    viewBox: "0 0 54.024 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75552",
    "data-name": "Group 75552",
    transform: "translate(-172.774 -363.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69565",
    "data-name": "Path 69565",
    d: "M201.215,398.434h.221a3.657,3.657,0,1,1-3.674,3.657,1.868,1.868,0,1,0-3.736,0,7.422,7.422,0,0,0,5.32,7.091v.837a1.868,1.868,0,0,0,3.736,0v-.725a7.392,7.392,0,0,0-1.644-14.6h-.221a3.657,3.657,0,1,1,3.673-3.657,1.869,1.869,0,1,0,3.737,0,7.365,7.365,0,0,0-5.545-7.15v-.778a1.869,1.869,0,0,0-3.737,0v.782a7.392,7.392,0,0,0,1.87,14.542Z",
    transform: "translate(-1.721 -1.453)",
    fill: "#FFB31C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69566",
    "data-name": "Path 69566",
    d: "M200.036,418.392a22.014,22.014,0,1,0-22.014-22.014A22.038,22.038,0,0,0,200.036,418.392Zm-12.925-34.936a18.277,18.277,0,1,1-5.353,12.924A18.153,18.153,0,0,1,187.112,383.456Z",
    transform: "translate(-0.429 -0.891)",
    fill: "#FFB31C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69567",
    "data-name": "Path 69567",
    d: "M223.366,416.575a1.929,1.929,0,0,0-2.7.388,26.277,26.277,0,0,1-36.784,5.327,26.458,26.458,0,0,1-3.332-2.962l1.692-.977a1.563,1.563,0,0,0,.573-2.136,1.587,1.587,0,0,0-.572-.571l-7.123-4.112a1.564,1.564,0,0,0-2.344,1.354v8.223a1.562,1.562,0,0,0,2.344,1.353l2-1.157a30.167,30.167,0,0,0,22.5,10.069h0a30.163,30.163,0,0,0,24.132-12.1A1.934,1.934,0,0,0,223.366,416.575Z",
    transform: "translate(0 -3.912)",
    fill: "#FFB31C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69568",
    "data-name": "Path 69568",
    d: "M225.47,372.163a1.559,1.559,0,0,0-.781.209l-2,1.157a30.136,30.136,0,0,0-46.61,2.006,1.928,1.928,0,0,0,.277,2.714,1.93,1.93,0,0,0,2.718-.281l.072-.1a26.278,26.278,0,0,1,36.784-5.326,26.42,26.42,0,0,1,3.332,2.961l-1.694.978a1.562,1.562,0,0,0,0,2.705l7.122,4.111a1.562,1.562,0,0,0,2.344-1.352l0-8.226A1.564,1.564,0,0,0,225.47,372.163Z",
    transform: "translate(-0.234)",
    fill: "#FFB31C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySell);
export default __webpack_public_path__ + "static/media/buy-sell.2496157d3e4a83721251f57174e4f3da.svg";
export { ForwardRef as ReactComponent };